import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v4h10V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 8v14h10V8H7z"
})), 'Battery90Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Battery90Sharp.js
// module id = 2271
// module chunks = 2